// removed by extract-text-webpack-plugin
module.exports = {"tableWrapper":"app-pages-Reports-Sales-ItemSales-__ItemSales___sw1vw","tableWrapper_without_scroll":"app-pages-Reports-Sales-ItemSales-__ItemSales___2b5FH","tableWrapperResponsive":"app-pages-Reports-Sales-ItemSales-__ItemSales___1rSPV","header_panel":"app-pages-Reports-Sales-ItemSales-__ItemSales___7bXOl","body_gross_margin":"app-pages-Reports-Sales-ItemSales-__ItemSales___3Vzsl","foot_gross_margin":"app-pages-Reports-Sales-ItemSales-__ItemSales___2HmXN","thickTitle":"app-pages-Reports-Sales-ItemSales-__ItemSales___3pAtn"};


//////////////////
// WEBPACK FOOTER
// ./app/pages/Reports/Sales/ItemSales/ItemSales.css
// module id = 2220
// module chunks = 0